export default import.meta.ROLLDOWN_FILE_URL_0qvla2bVg1MBHJB3warEDA